import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';

import colorContrast from 'color-contrast';
import logo_hr from '../../../assets/images/brand/assista_horizontal-punchout.svg';
import logo from '../../../assets/images/brand/assista.svg';

export const Navbar = ({user, deceasedUser, deathDeclaration, partnerColor, logoContent, subsectionsStatuses, serviceSubsectionsStatuses, profilePicture}) => {
    const router = useSelector(state => state.router);
    const [widthIsBigger, setWidthIsBigger] = useState(false);

    useEffect(() => {
        if (!R.isNil(profilePicture)) {
            let i = new Image();
            i.onload = function () {
                setWidthIsBigger(i.width > i.height);
            };
            i.src = profilePicture;
        }
    }, [profilePicture]);

    let onBoardingStepDefault = "0";
    if(!R.isNil(deceasedUser.onBoardingStep) && (typeof deceasedUser.onBoardingStep === 'string' || deceasedUser.onBoardingStep instanceof String)){
        if(deceasedUser.onBoardingStep === "Completed"){
            onBoardingStepDefault = 6;
        }else{
            onBoardingStepDefault = parseInt(deceasedUser.onBoardingStep.replace(/\D/g, ""));
        }

    }

    const [onBoardingStep, setOnBoardingStep] = useState(onBoardingStepDefault);

    useEffect(() => {
        if(!R.isNil(deceasedUser.onBoardingStep)){
            if((typeof deceasedUser.onBoardingStep === 'string' || deceasedUser.onBoardingStep instanceof String)){
                if(deceasedUser.onBoardingStep === "Completed"){
                    setOnBoardingStep(6);
                }else{
                    setOnBoardingStep(parseInt(deceasedUser.onBoardingStep.replace(/\D/g, "")));
                }
            }else{
                setOnBoardingStep(deceasedUser.onBoardingStep);
            }
        }


    }, [deceasedUser.onBoardingStep])

    const colorCustom = (!R.isNil(partnerColor) && partnerColor !== '') ? (colorContrast('#fff', partnerColor) >= 2.5 ? " text-white navbar-dark" : " navbar-light") : " text-white navbar-dark";
    const logo = R.isNil(logoContent) ? logo_hr : logoContent;
    return (
        <header className={"aside onboard-aside navbar navbar-expand-lg py-4 pt-lg-5" + colorCustom}>
            <div className="container-fluid px-gutter justify-content-between align-item-center d-md-flex flex-lg-column h-100">
                <Link className="navbar-brand mr-lg-auto" to={`/facilita`}>
                    <img className={"img-fluid" + (logoContent ? " rounded-sm img-avatar" : "")} src={logo} alt={"Assist@" + (logoContent ? " Partner" : "")} height="80" width="212" onError={(ev) => ev.target.src = logo_hr} />
                    {/* <img className="img-fluid" src={logo} alt="Assist@" width={R.isNil(logoContent) ? "224" :"180"} onError={(ev) => ev.target.src = logo_hr} /> */}
                    <h1 className="sr-only visually-hidden">Assist@: Menu</h1>
                </Link>
                <div className="d-flex align-items-center">
                    <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div className={"collapse navbar-collapse flex-column mt-3 mt-lg-0" + ((router.location.pathname === `/facilita/${deceasedUser.id}/declarer/step1`) ? ' ' : ' pb-lg-0')} id="navbar-collapse">
                    <nav className="card w-100 rounded-cta bg-stage flex-grow-0 mb-4 h-100 border-0">
                        <h1 className="sr-only visually-hidden">Menu: navigation</h1>
                        <div className="nav-item text-center">
                            <div className="h3 font-weight-bold lh-1 mt-3">{!R.isNil(user) ? `${user.firstName} ${user.lastName}` : 'The Undertaker'}</div>
                            <ul className="nav navbar-inline align-items-center justify-content-around container-paper mx-auto">
                                <NavLink className={"nav-item inline-item o-80 o-100--hover"} activeClassName="o-100 active" to="/facilita/settings">
                                    <div className="nav-link p-2 mb-0 lh-1">
                                        <i className="eva eva-settings-2-outline h3 lh-1 my-auto icon-default"></i>
                                    </div>
                                </NavLink>
                                <div role="button" className={"nav-item inline-item o-80 o-100--hover"} onClick={() => {
                                    localStorage.removeItem("access_token");
                                    setTimeout(() => {
                                        window.location = '/index';
                                    }, 100);
                                }}>
                                    <div className="nav-link p-2 mb-0 lh-1">
                                        <i className="eva eva-power-outline h3 lh-1 my-auto icon-default"></i>
                                    </div>
                                </div>
                            </ul>
                        </div>
                        <div className="nav-item show">
                            <div className="card bg-faded text-body shadow text-center">
                                <div className="card-header pb-0">
                                    <div className="h6 o-60 font-weight-bold lh-1 mb-1">Dossier de</div>
                                    <div className="h4 text-uppercase font-weight-bold lh-1 mb-0">{deceasedUser.firstName} {deceasedUser.lastName}</div>
                                </div>
                                <div className="card-footer">
                                    <div className="h6 o-60 font-weight-bold lh-1 mb-1">Numéro de processus</div>
                                    <div className="h4 font-weight-bold lh-1 mb-0">{!R.isNil(deceasedUser) && deceasedUser.processNumber !== '' ?  deceasedUser.processNumber : 'N/D'}</div>
                                </div>
                            </div>
                            <ul className="card-body navbar-nav">
                                <NavLink className={"nav-item" + ((onBoardingStep > 1) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/onboarding/step1`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Informations du défunt</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                    <div className="feedback text-body">
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.civilForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Etat civil</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small"  + (subsectionsStatuses.familySituationForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Situation familiale</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.childrenForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Enfants</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.residenceForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Coordonnées</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small" + (subsectionsStatuses.professionalSituationForm ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Situation Professionnelle</span>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 3) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/onboarding/step2`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Le service</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                    <div className="feedback text-body">
                                        <div role="button" className={"d-flex align-items-center small text-white"}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Démarches communes</span>
                                        </div>
                                        <div role="button" className={"d-flex align-items-center small"  + (serviceSubsectionsStatuses.demarchesPersonalisee ? "  text-white" : " o-50")}>
                                            <i className="eva eva-checkmark-circle-outline mr-2"></i>
                                            <span className="">Démarches personnalisées</span>
                                        </div>
                                    </div>
                                </NavLink>
                                <NavLink className={"nav-item" + ((onBoardingStep > 4) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/onboarding/step3`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">La situation du défunt</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink>
                                {/* <NavLink className={"nav-item" + ((onBoardingStep > 5) ? ' done' : '')} activeClassName="active text-white" to={`/facilita/${deceasedUser.id}/onboarding/step4`}>
                                    <div className="nav-link d-flex w-100 justify-content-between mb-0 text-inherit">
                                        <span className="font-weight-bolder text-uppercase ls-n1">Résumé</span>
                                        <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                            <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                        </div>
                                    </div>
                                </NavLink> */}
                            </ul>
                        </div>
                        <button type="button" className={"btn btn-light text-primary mx-auto border-none px-3 rounded mb-3 ls-n1 fs-3" + (router.location.pathname === `/facilita/settings` ? " mt-3" : " mt-auto")} onClick={(e) => {
                                    e.preventDefault();
                                    window.location = "/funecap/dossiers";
                                }}>Voir tous mes dossiers</button>
                    </nav>
                    
                    {/* <Link className="btn btn-light btn-block px-2 mt-auto text-body" to="/facilita">Annuler</Link> */}
                </div>
            </div>
        </header>
    )
}